// src/index.ts
var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var EMAIL_REGEX_STRICT = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
var EMAIL_REGEX_SENDABLE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
var EMAIL_IN_TEXT_REGEX = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
var MAILTO_EMAIL_IN_TEXT_REGEX = /mailto:([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
var ANONYMOUS_EMAIL = "anonymous@donoor.org";
function isValidEmail(email) {
  if (!email || typeof email !== "string") return false;
  const trimmed = email.trim();
  if (!trimmed) return false;
  return EMAIL_REGEX.test(trimmed);
}
function isValidEmailStrict(email) {
  if (!email || typeof email !== "string") return false;
  const trimmed = email.trim();
  if (!trimmed) return false;
  if (trimmed === ANONYMOUS_EMAIL) return false;
  return EMAIL_REGEX_STRICT.test(trimmed);
}
function isSendableEmail(email) {
  if (!email || typeof email !== "string") return false;
  const trimmed = email.trim();
  if (!trimmed) return false;
  return EMAIL_REGEX_SENDABLE.test(trimmed);
}
function extractEmails(text) {
  if (!text || typeof text !== "string") return [];
  return text.match(EMAIL_IN_TEXT_REGEX) ?? [];
}
function extractMailtoEmails(html) {
  if (!html || typeof html !== "string") return [];
  return [...html.matchAll(MAILTO_EMAIL_IN_TEXT_REGEX)].map((m) => m[1]);
}
function normalizeEmail(email) {
  if (!email || typeof email !== "string") return null;
  const trimmed = email.trim().toLowerCase();
  return trimmed || null;
}
var RESERVED_TEST_EMAIL_DOMAINS = /* @__PURE__ */ new Set([
  "example.com",
  "example.net",
  "example.org",
  "example.edu"
]);
function isReservedTestEmailDomain(email) {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  const domain = normalized.split("@")[1];
  return !!domain && RESERVED_TEST_EMAIL_DOMAINS.has(domain);
}
function hasTestEmailLocalPart(email) {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  const localPart = normalized.split("@")[0];
  return !!localPart && /^test/.test(localPart);
}
function isPlaceholderTestName(firstName, lastName) {
  const f = (firstName ?? "").trim().toLowerCase();
  const l = (lastName ?? "").trim().toLowerCase();
  return f === "john" && l === "doe";
}
function isEmpty(value) {
  if (!value || typeof value !== "string") return true;
  return value.trim().length === 0;
}
function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}
var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var UUID_GENERIC_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function isValidUUID(value) {
  if (!value || typeof value !== "string") return false;
  return UUID_REGEX.test(value.trim());
}
function isValidUUIDAnyVersion(value) {
  if (!value || typeof value !== "string") return false;
  return UUID_GENERIC_REGEX.test(value.trim());
}
function isValidSIRET(siret) {
  if (!siret || typeof siret !== "string") return false;
  const cleaned = siret.replace(/\s/g, "");
  if (!/^\d{14}$/.test(cleaned)) return false;
  let sum = 0;
  for (let i = 0; i < 14; i++) {
    let digit = Number.parseInt(cleaned[13 - i] ?? "0", 10);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
}
function isValidRNA(rna) {
  if (!rna || typeof rna !== "string") return false;
  const cleaned = rna.trim().toUpperCase();
  return /^W\d{8,9}$/.test(cleaned);
}
function isValidIBAN(iban) {
  if (!iban || typeof iban !== "string") return false;
  const cleaned = iban.replace(/\s/g, "").toUpperCase();
  if (cleaned.length < 15 || cleaned.length > 34) return false;
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(cleaned)) return false;
  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);
  let numericString = "";
  for (const c of rearranged) {
    if (c >= "0" && c <= "9") {
      numericString += c;
    } else {
      numericString += String(c.charCodeAt(0) - "A".charCodeAt(0) + 10);
    }
  }
  let remainder = 0;
  for (let i = 0; i < numericString.length; i += 7) {
    const segment = String(remainder) + numericString.slice(i, i + 7);
    remainder = Number.parseInt(segment, 10) % 97;
  }
  return remainder === 1;
}
function isValidURL(url) {
  if (!url || typeof url !== "string") return false;
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
var SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
function isValidSlug(slug) {
  if (!slug || typeof slug !== "string") return false;
  return SLUG_REGEX.test(slug);
}

export { ANONYMOUS_EMAIL, EMAIL_REGEX, EMAIL_REGEX_SENDABLE, EMAIL_REGEX_STRICT, SLUG_REGEX, UUID_GENERIC_REGEX, UUID_REGEX, extractEmails, extractMailtoEmails, hasTestEmailLocalPart, isEmpty, isNonEmptyString, isPlaceholderTestName, isReservedTestEmailDomain, isSendableEmail, isValidEmail, isValidEmailStrict, isValidIBAN, isValidRNA, isValidSIRET, isValidSlug, isValidURL, isValidUUID, isValidUUIDAnyVersion, normalizeEmail };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map